import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const facialValidationActiveState = atom<boolean>({
  key: 'facialValidationActive',
  default: true,
  effects_UNSTABLE: [persistAtom],
});
